'use strict';

/* global $ */

import { breakpoints } from '../settings'

function LandSliders (options) {
    let branch = '.js-land-branch';
    let permis = '.js-land-permis';
    let gallery = '.js-land-gallery';
    let clients = '.js-land-clients';
    let projects = '.js-land-projects';
    let steps = '.js-land-steps';
    let stepsSlider = '.js-landing-steps';

    $(branch).each(function() {
        InitBranchSlider(this); 
    });

    $(permis).each(function() {
        InitPermisSlider(this); 
    });

    $(gallery).each(function() {
        InitGallerySlider(this); 
    });

    $(clients).each(function() {
        InitClientSlider(this); 
    });

    $(projects).each(function() {
        MoreProjects(this); 
    });

    $(steps).each(function() {
        // StepScrollAnime(this);
        StepHideContent(this);
    });

    $(stepsSlider).each(function() {
        SlickSteps(this); 
    });

}

function StepHideContent (block) {
    let item = '.js-land-steps__item';
    let $item = $(block).find(item);

    $($item).each(function() {
        StepToggleContent(this); 
    });
}

function StepToggleContent (item) {
    let content = '.js-land-steps__content';
    let $content = $(item).find(content);

    let standartHeight = 48; //2x line-height
    if ($content.height() > 48) {
        let text = $content.find('.text');
        let oldHeight = $content.height();
        text.css('max-height', standartHeight);
        let link = document.createElement('a');
        link.className = 'land-steps__more';
        link.innerText = 'подробнее..';
        $(link).on('click', function () {
            if (text.height() <= standartHeight) {
                text.css('max-height', oldHeight);
                link.innerText = 'скрыть';
            } else {
                text.css('max-height', standartHeight);
                link.innerText = 'подробнее..';
            }
        });
        $content.append(link);
    }

}

function StepScrollAnime (block) {
    let item = '.js-land-steps__item';
    let $item = $(block).find(item);

    $($item).each(function() {
        CheckStepsItems(this); 
    });

    $(window).on('scroll', function () {
        $($item).each(function() {
            CheckStepsItems(this); 
        });
    });
}

function SlickSteps(item) {
    let numbers = $(item).find('.js-landing-steps__numbers');
    let items = $(item).find('.js-landing-steps__items');

    $(items).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<a class="slick-prev"></a>',
      nextArrow: '<a class="slick-next"></a>',
      fade: false,
      infinite: false,
      centerMode: false,
      draggable: true,
      accessibility: false,
      asNavFor: numbers,
    });
    $(numbers).slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: items,
      dots: false,
      arrows: false,
      infinite: false,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: true,
      draggable: false,
      responsive: [
            {
                breakpoint: breakpoints.s,
                settings: {
                    slidesToShow: 5,
                    variableWidth: false,
                    draggable: true,
                    centerMode: true
                }
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 4,
                    variableWidth: false,
                    draggable: true,
                    centerMode: true
                }
            },
            {
                breakpoint: breakpoints.xxs,
                settings: {
                    slidesToShow: 3,
                    variableWidth: false,
                    centerMode: true,
                    draggable: true
                }
            }
        ]
    });
}

function CheckStepsItems (item) {
    let h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    let w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
    // let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let itemTop = item.getBoundingClientRect().top;
    let itemHeight = item.getBoundingClientRect().height;

    let HideBorder = 0;
    if ( w > breakpoints.s) {
        HideBorder =  itemHeight;
    }

    let index = $(item).find('.js-land-steps__index');
    let block = $(item).find('.js-land-steps__block');
    let image = $(item).find('.js-land-steps__image');

    if (itemTop + itemHeight < h && itemTop > HideBorder) {

        $(index).css('z', 1);
        $(block).css('opacity', 1);
        $(image).css({ "opacity" : 1, "margin" : '-1px 0 0 -1px' });
    } else {
        $(index).css('opacity', 0.3);
        $(block).css('opacity', 0.3);
        $(image).css({ "opacity" : 0.3, "margin" : 0 });
    }
}

function InitBranchSlider (item) {
    let slider = ('.js-land-branch__slider');
    let arrows = ('.js-land-branch__arrow');
    let $arrows = $(item).find(arrows);
    let $slider = $(item).find(slider);

    let LeftArrow = $arrows.filter('.m--prev');
    let RightArrow = $arrows.filter('.m--next');

    $($slider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: LeftArrow,
        nextArrow: RightArrow,
        arrows: true,
        dots: false,
        fade: false,
        infinite: false,
        draggable: false,
        accessibility: false,
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 3.5,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.m,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                    infinite: false
                }
            },

            {
                breakpoint: breakpoints.s+120,
                settings: {
                    slidesToShow: 2.5,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.s,
                settings: {
                    slidesToShow: 2,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 1.5,
                    draggable: true,
                    dots: false,
                    infinite: false
                }
            },
            {
                breakpoint: breakpoints.xxs,
                settings: {
                    slidesToShow: 1,
                    draggable: true,
                    dots: false,
                    infinite: false
                }
            },
        ]
    });
}

function InitPermisSlider (item) {
    let slider = ( '.js-land-permis__slider');
    let arrows = ( '.js-land-permis__arrow');
    let $arrows = $(item).find(arrows);
    let $slider = $(item).find(slider);

    let LeftArrow = $arrows.filter('.m--prev');
    let RightArrow = $arrows.filter('.m--next');

    $($slider).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: LeftArrow,
        nextArrow: RightArrow,
        arrows: true,
        dots: false,
        fade: false,
        infinite: true,
        draggable: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 4.5,
                    dots: false,
                }
            },
            {
                breakpoint: breakpoints.m,
                settings: {
                    slidesToShow: 4,
                    dots: false,
                }
            },

            {
                breakpoint: breakpoints.s+120,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                }
            },
            {
                breakpoint: breakpoints.s,
                settings: {
                    slidesToShow: 2.5,
                    dots: false,
                }
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 2,
                    draggable: true,
                    dots: false,
                }
            },
            {
                breakpoint: breakpoints.xs - 100,
                settings: {
                    slidesToShow: 1.5,
                    dots: false,
                }
            },
            {
                breakpoint: breakpoints.xxs,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                }
            },
        ]
    });
}

function InitGallerySlider (item) {
    let slider = '.js-land-gallery__slider';
    let arrows = '.js-land-gallery__arrow';
    let $arrows = $(item).find(arrows);
    let $slider = $(item).find(slider);

    let LeftArrow = $arrows.filter('.m--prev');
    let RightArrow = $arrows.filter('.m--next');

    $($slider).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: LeftArrow,
        nextArrow: RightArrow,
        arrows: true,
        dots: false,
        fade: false,
        infinite: true,
        draggable: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: breakpoints.xxs,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
}

function InitClientSlider (item) {
    let slider = '.js-land-clients__slider';
    let arrows = '.js-land-clients__arrow';
    let $arrows = $(item).find(arrows);
    let $slider = $(item).find(slider);

    let LeftArrow = $arrows.filter('.m--prev');
    let RightArrow = $arrows.filter('.m--next');

    $($slider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: LeftArrow,
        nextArrow: RightArrow,
        arrows: true,
        dots: false,
        fade: false,
        infinite: true,
        draggable: true,
        accessibility: false,
        //variableWidth: true,
        responsive: [
            {
                breakpoint: breakpoints.m,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: breakpoints.s,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
}

function MoreProjects(block) {
    let linkSel = '.js-land-projects__link';
    let itemsSel = '.js-land-projects__items';
    let itemSel = '.js-land-projects__item';
    let items = $(block).find(itemsSel);
    let link = $(block).find(linkSel);
    let item = $(items).find(itemSel);

    $(item).slice(0).hide();
    $(item).slice(0, 2).show();

    if ($(item).filter(":hidden").length == 0) {
        $(link).fadeOut('slow');
    }

    $(link).on('click', function (e) {
        e.preventDefault();
        $(item).filter(':hidden').slice(0, 2).slideDown();
        if ($(item).filter(":hidden").length == 0) {
            $(link).fadeOut('slow');
        }
    });
}

export {
    LandSliders
};